import RunConfigService from './runConfigService.js';

/**
 *
 * BrowserDetection object is immediately executed when the page loads.
 * This Object is used to detect the browser and version the user is using.
 *
 * @namespace MarketSiteRegions
 */
class MarketSiteRegions {
    constructor() {

    }

    getMarketSiteRegionData(isGlobalLanding) {
        if (isGlobalLanding) {
            this.REGIONS_SERVICE_URL = RunConfigService.getBaseUrl() + "/apps/hello/services/regions.globallanding.json";
        } else {
            this.REGIONS_SERVICE_URL = RunConfigService.getBaseUrl() + "/apps/hello/services/regions.json";
        }
        let deferred = $.Deferred();
        $.ajax({
            type: "GET",
            url: this.REGIONS_SERVICE_URL,
            success: data => {
                deferred.resolve(data);
            },
            error: xhr => {
                deferred.reject(xhr);
            }
        });
        return deferred.promise();
    }

    getMarketSiteRegionByCountry (country) {
        return this.getMarketSiteRegionData(true).then(data => data.find(regionData => {
            var selectedCountry = regionData.countryname.find(region => region.countryCode === country);
            if(!!selectedCountry) {
                return selectedCountry;
            } else {
                return "";
            };
        }))
    }
}

export default new MarketSiteRegions();
